import React from "react";
import RatingPage from "../../components/rating";
import Page from "../../components/general/page";
import { FormattedMessage } from "react-intl";

const RatingView = props => {
  const { pageRef } = props;

  return (
    <Page
      pageRef={pageRef}
      title={"DISTRIBUZIONE AZIENDE PER RATING"}
      subtitle={""}      
      backText={<FormattedMessage id="deadlines.goBack" />}
      backUrl="/"
    >
      <RatingPage />
    </Page>
  );
};

export default RatingView;